import React from "react";
import * as Scrivito from "scrivito";
import { ItemsPerPageSelect } from "components";
import { useAppBaseContext } from "providers";
import { ProjectListFilters } from "./ProjectListFilters";
import { ProjectSearchInput } from "./ProjectSearchInput";
import { DeleteProjectsButton } from "./DeleteProjectsButton";
import { useProjectListContext } from "../../hooks/useProjectListContext";
import { DepartmentDropdown } from "./DepartmentDropdown";

export const ProjectListControls = Scrivito.connect(() => {
  const { isSameProj } = useAppBaseContext();

  const { projectsToDelete, itemsPerPage, handleItemsPerPageChange } =
    useProjectListContext();

  return (
    <>
      {isSameProj ? (
        <SameControls
          projectsToDelete={projectsToDelete}
          itemsPerPage={itemsPerPage}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      ) : (
        <ConfiguratorControls
          projectsToDelete={projectsToDelete}
          itemsPerPage={itemsPerPage}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}
    </>
  );
});

const ConfiguratorControls = ({
  projectsToDelete,
  itemsPerPage,
  handleItemsPerPageChange,
}) => (
  <>
    <div
      data-testid="CONFIGURATOR_CONTROLS"
      className="d-flex justify-content-between align-items-start py-3"
    >
      {projectsToDelete.length > 0 ? (
        <DeleteProjectsButton className="col-3 me-5" />
      ) : (
        <ProjectSearchInput className="col-3 me-5" />
      )}
      <div className="d-flex flex-nowrap justify-content-end gap-2 w-100">
        <ProjectListFilters className="justify-content-end" />
      </div>
    </div>
    <ItemsPerPageSelect
      itemsPerPage={itemsPerPage}
      onChange={handleItemsPerPageChange}
      className="mb-3"
    />
  </>
);

const SameControls = ({
  projectsToDelete,
  itemsPerPage,
  handleItemsPerPageChange,
}) => (
  <>
    <div
      data-testid="SAME_CONTROLS"
      className="d-flex justify-content-start align-items-end py-3 gap-3"
    >
      <DepartmentDropdown />
      <ItemsPerPageSelect
        itemsPerPage={itemsPerPage}
        onChange={handleItemsPerPageChange}
      />
      <div className="d-flex flex-row flex-grow-1 justify-content-end col-3">
        {projectsToDelete.length > 0 ? (
          <DeleteProjectsButton className="w-100" />
        ) : (
          <ProjectSearchInput className="w-100" />
        )}
      </div>
    </div>
    <div className="d-flex flex-nowrap justify-content-start gap-2 mb-3">
      <ProjectListFilters className="justify-content-start" />
    </div>
  </>
);
